<template>
    <div class="main-tests">
        <div class="tests tests-mobile">
            <div class="tests-container tests-container-mobile">
                <div class="task_types">
                    <div class="select-list">
                        <div class="tasks_header-mobile">
                            <h1>{{ title }}</h1>
                        </div>
                        <div class="block-type-text">
                            <span class="title-type">Тип</span>
                        </div>
                        <div class="select-list_drop">
                            <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="white"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                    <span>{{ testTypes.length > currentType ? testTypes[currentType] : '' }}</span>
                                    <div class="drop-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                        </svg>
                                    </div>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(item, index) in testTypes"
                                        :key="index"
                                        @change="changeType(index, searchText)"
                                    >
                                        <v-list-item-title>{{ item }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                    <div class="tasks_search">
                        <!-- <label for="search_name">Поиск по коду или названию</label> -->
                        <input placeholder="Поиск" v-model="searchText" @input="searchDebounce(searchText)" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667C15.8333 10.7068 15.3111 12.125 14.4339 13.2538L17.6726 16.4941L16.4941 17.6726L13.2538 14.4339C12.125 15.3111 10.7068 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5ZM9.16667 4.16667C6.40524 4.16667 4.16667 6.40524 4.16667 9.16667C4.16667 11.9281 6.40524 14.1667 9.16667 14.1667C11.9281 14.1667 14.1667 11.9281 14.1667 9.16667C14.1667 6.40524 11.9281 4.16667 9.16667 4.16667Z" fill="#AAAEB7"/>
                        </svg>
                    </div>
                </div>
                <div class="tasks_header">
                    <h1>{{ title }}</h1>
                </div>
                <div v-if="currentType === 0" class="tests_item-container">
                    <div v-show="!loadingTask" v-for="(item, index) in tasks" :key="'Aa'+index" class="tests_item">
                        <div class="item-header">
                            <div class="icon-container">
                                <inline-svg :src="getIcon(item)" />
                            </div>
                            <p>{{ item.title }}</p>
                        </div>
                        <PassTypeBadge :assign="item" />
                        <div class="item-body">
                            <div class="item-body-name">
                                <p class="txt top">Название теста</p>
                                <p class="txt bot">{{ item.title }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Дисциплина</p>
                                <p class="txt bot">{{ item.studyDisciplineName }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Тема</p>
                                <p class="txt bot">{{ item.studyTopicName }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Срок сдачи</p>
                                <p class="txt bot">{{ getCompletionDates(item) }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Повторное прохождение</p>
                                <p class="txt bot">{{ item.isRepeat || item.passTypeId === '1e945105-9fa3-46f6-811b-91d4ecde6f4e' ? 'Да' : 'Нет' }}</p>
                            </div>
                        </div>
                        <PassLearningButton :assign="item" :loading="loadingPassTypes" />
                    </div>

                    <v-skeleton-loader
                        v-show="loadingTask"
                        v-for="(item, index) in 3"
                        :key="'Bb'+index"
                        class="tests_item"
                        type="list-item-avatar-three-line, image, article"
                    />
                </div>
                <div v-if="currentType === 1" class="tests_item-container">
                    <div v-show="!loadingTask" v-for="(item, index) in tasks" :key="'B'+index" class="tests_item diag_item">
                        <div class="item-header diag-header">
                            <div class="icon-container diag-icon">
                                <img width="64" height="64" :src="getPhotoUrl(item)" alt="icon">
                            </div>
                            <div class="header-info">
                                <p>{{ item.patientFio }}</p>
                                <div class="info-bot">
                                    <p>Пол: <span :class="{'male': item.patientGender == 0, 'female': item.patientGender == 1 }">
                                        {{ item.patientGender == 0 ? 'М' : 'Ж' }}
                                    </span></p>
                                    <p>Возраст: <span class="header-age">{{ item.patientAgeString }}</span></p>
                                </div>
                            </div>
                        </div>
                        <PassTypeBadge :assign="item" />
                        <div class="item-body diag-body">
                            <div class="body-item">
                                <p class="item-top">Название теста</p>
                                <p class="item-bot">{{ item.title }}</p>
                            </div>
                            <div class="body-item">
                                <p class="item-top">Дисциплина</p>
                                <p class="item-bot">{{ item.studyDisciplineName }}</p>
                            </div>
                            <div class="body-item">
                                <p class="item-top">Тема</p>
                                <p class="item-bot">{{ item.studyTopicName }}</p>
                            </div>
                            <div class="body-item">
                                <p class="item-top">Краткое описание</p>
                                <p class="item-bot">{{ item.description }}</p>
                            </div>
                            <div class="body-item">
                                <p class="item-top">Срок сдачи</p>
                                <p class="item-bot">{{ getCompletionDates(item) }}</p>
                            </div>
                            <div class="body-item">
                                <p class="item-top">Повторное прохождение</p>
                                <p class="item-bot">{{ item.isRepeat || item.passTypeId === '1e945105-9fa3-46f6-811b-91d4ecde6f4e' ? 'Да' : 'Нет' }}</p>
                            </div>
                        </div>
                        <PassDiagnosticsButton :assign="item" :loading="loadingPassTypes && loadStartDiagnostic" />
                    </div>

                    <v-skeleton-loader
                        v-show="loadingTask"
                        v-for="(item, index) in 3"
                        :key="'Bb'+index"
                        class="tests_item"
                        type="list-item-avatar-three-line, image, article"
                    />
                </div>
                <div class="data-footer">
                    <div class="pagination" v-if="params.pageSize != allItemsSize">
                        <span>Cтраница:</span>
                        <div class="pagination_prev" @click.prevent="prevPage">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                            </svg>
                        </div>
                        <div class="pagination_number">
                            {{ params.currentPage + 1 }}
                        </div>
                        <div class="pagination_next" v-if="params.pageSize" @click.prevent="nextPage">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                            </svg>
                        </div>
                    </div>
                    <div class="select-list">
                        <span>Выводить:</span>
                        <div class="select-list_drop">
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="white"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <span>{{ params.pageSize != allItemsSize ? params.pageSize : 'Все' }}</span>
                                <div class="drop-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                </svg>
                                </div>
                            </v-btn>
                            </template>
                            <v-list>
                            <v-list-item
                                v-for="(item, index) in pageSizes"
                                :key="index"
                                @change="updatePageSize(item.size)"
                            >
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </v-list-item>
                            </v-list>
                        </v-menu>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tests-container-mobile-block">
                <h1>Список тестов</h1>
                <div v-if="currentType === 0" class="tests_item-container-mobile">
                    <div v-for="(item, index) in tasks" :key="'A'+index" class="tests_item">
                        <div class="item-header">
                            <div class="icon-container">
                                <inline-svg :src="getIcon(item)" />
                            </div>
                            <p>{{ item.title }}</p>
                        </div>
                        <PassTypeBadge :assign="item" />
                        <div class="item-body">
                            <div class="item-body-name">
                                <p class="txt top">Название теста</p>
                                <p class="txt bot">{{ item.title }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Дисциплина</p>
                                <p class="txt bot">{{ item.studyDisciplineName }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Тема</p>
                                <p class="txt bot">{{ item.studyTopicName }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Срок сдачи</p>
                                <p class="txt bot">{{ getCompletionDates(item) }}</p>
                            </div>
                            <div class="item-body-name">
                                <p class="txt top">Повторное прохождение</p>
                                <p class="txt bot">{{ item.isRepeat ? 'Да' : 'Нет' }}</p>
                            </div>
                        </div>
                        <PassLearningButton :assign="item" :loading="loadingPassTypes" />
                    </div>
                </div>
                <div v-if="currentType === 1" class="tests_item-container-diag">
                    <div v-for="(item, index) in tasks" :key="'B'+index" class="tests_item-diag">
                        <div class="item-header-diag">
                            <div class="icon-container-diag">
                                <img :src="getPhotoUrl(item)" alt="icon">
                            </div>
                            <div class="header-info-diag">
                                <p>{{ item.patientFio }}</p>
                                <div class="info-bot-diag">
                                    <p>Пол: <span :class="{'male': item.patientGender == 0, 'female': item.patientGender == 1 }">
                                        {{ item.patientGender == 0 ? 'М' : 'Ж' }}</span></p>
                                        <p>Возраст: <span class="header-age">{{ item.patientAgeString}}</span></p>
                                </div>
                            </div>
                        </div>
                        <PassTypeBadge :assign="item" />
                        <div class="item-body-diag">
                            <div class="item-body-name-diag">
                                <p class="txt item-top">Название теста</p>
                                <p class="txt item-bot">{{ item.title }}</p>
                            </div>
                            <div class="item-body-name-diag">
                                <p class="txt item-top">Дисциплина</p>
                                <p class="txt item-bot">{{ item.studyDisciplineName }}</p>
                            </div>
                            <div class="item-body-name-diag">
                                <p class="txt item-top">Тема</p>
                                <p class="txt item-bot">{{ item.studyTopicName }}</p>
                            </div>
                            <div class="item-body-name-diag">
                                <p class="txt item-top">Краткое описание</p>
                                <p class="txt item-bot">{{ item.description }}</p>
                            </div>
                            <div class="item-body-name-diag">
                                <p class="txt item-top">Срок сдачи</p>
                                <p class="txt item-bot">{{ getCompletionDates(item) }}</p>
                            </div>
                            <div class="item-body-name-diag">
                                <p class="txt item-top">Повторное прохождение</p>
                                <p class="txt item-bot">{{ item.isRepeat ? 'Да' : 'Нет' }}</p>
                            </div>
                        </div>
                        <PassDiagnosticsButton :assign="item" :loading="loadingPassTypes && loadStartDiagnostic" />
                    </div>
                </div>
            </div>
            <div class="data-footer-mobile">
                <div class="pagination" v-if="params.pageSize != allItemsSize">
                    <div class="pagination_prev" @click.prevent="prevPage">
                        <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                        </svg>
                    </div>
                    <div class="pagination_number">
                        {{ params.currentPage + 1 }}
                    </div>
                    <div class="pagination_next" v-if="params.pageSize" @click.prevent="nextPage">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                        </svg>
                    </div>
                </div>
                <div class="select-list">
                    <div class="select-list_drop">
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="white"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <span>{{ params.pageSize != allItemsSize ? params.pageSize : 'Все' }}</span>
                                    <div class="drop-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41079 14.5118L3.57745 8.67851L4.75596 7.5L10 12.7441L15.2441 7.5L16.4226 8.67851L10.5893 14.5118C10.2639 14.8373 9.73622 14.8373 9.41079 14.5118Z" fill="black"/>
                                        </svg>
                                    </div>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in pageSizes"
                                    :key="index"
                                    @change="updatePageSize(item.size)"
                                >
                                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';
import InlineSvg from 'vue-inline-svg';
import { mapGetters } from 'vuex';
import { helpers } from '@/store/tests';
import PassTypeBadge from './PassTypeBadge.vue';
import PassLearningButton from './PassLearningButton.vue';
import PassDiagnosticsButton from './PassDiagnosticsButton.vue';
import "./index.scss";

const AllItemsSize = 10000;

export default {
    components: {
        InlineSvg, PassTypeBadge, PassLearningButton, PassDiagnosticsButton
    },
    data() {
        return {
            loadingPassTypes: false,
            loadingTask: true,
            searchText: '',
            loadStartDiagnostic: false,
            title: 'Обучающие тесты по системам организма',
            testTypes: helpers.testTypes,
            currentType: 0,
            params: {
                filters: [],
                pageSize: 10,
                currentPage: 0,
                useANDoperator: false,
                columns: []
            },
            passTypes: [],
            tasks: [],
            pagesCount: 0,
            allItemsSize: AllItemsSize,
            pageSizes: [
                { name: '5', size: 5 },
                { name: '10', size: 10 },
                { name: '15', size: 15 },
                { name: 'Все', size: AllItemsSize }
            ]
        }
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            apiImg: 'apiImg',
            user: 'user/userInfo'
        })
    },
    methods: {
        changeType(taskType, text) {
            this.title = taskType === 0 ? 'Обучающие тесты по системам организма' : 'Список пациентов';
            this.currentType = taskType;
            localStorage.setItem('taskTypeM', taskType);
            this.loadTasks();
        },
        loadPassTypes() {
            this.loadingPassTypes = true;

            this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                .then((response) => {
                    this.passTypes = response.data;
                    this.loadingPassTypes = false;
            });
        },
        getPassTypeId(keyName) {
            let found = this.passTypes.find(x => x.keyName === keyName);

            if (found !== undefined) {
                return found.id;
            }

            return null;
        },
        loadTasks() {
            this.tasks = [];
            this.$http.post(`${this.apiUrl}Student/GetStudentViewTests?testType=${this.currentType}`, this.params)
                .then((result) => {
                    this.tasks = result.data.data;
                    this.pagesCount = this.params.pageSize ? Math.ceil(result.data.totalRecords / this.params.pageSize) : 1;
                    this.loadingTask = false;
                });
        },
        getCompletionDates(item) {
            if (item.dateFrom === null || item.dateTo === null) {
                return '–';
            }

            return new Date(item.dateFrom).toLocaleDateString('ru-RU') + ' – ' + new Date(item.dateTo).toLocaleDateString('ru-RU');
        },
        getIcon(task) {
            if (task.bodySystemIconUrl) {
                return require(`../../../assets/SomaticStatus/${task.bodySystemIconUrl}`);
            } 
            else {
                return '';
            }
        },
        getPhotoUrl(student) {
            if (student.patientLogoUrl) {
                return `${this.apiImg}${student.patientLogoUrl}`;
            }

            if (student.gender === 0) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.gender === 1) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        prevPage() {
            if (this.params.currentPage > 0) {
                this.params.currentPage--;
                this.loadingTask = true;
                this.loadTasks();
            }
        },
        nextPage() {
            if (this.params.currentPage < (this.pagesCount - 1)) {
                this.params.currentPage++;
                this.loadingTask = true;
                this.loadTasks();
            }
        },
        updatePageSize(size) {
            this.params.currentPage = 0;
            this.params.pageSize = size;
            this.loadTasks();
        },
        passLearningTest(assign, assignId, passTypeId) {
            if(!assign.questionsCount) assign.questionsCount = 10;

            this.$router.push(`/lkstudents/tests/${assign.testId}?assignId=${assignId}&passTypeId=${passTypeId}&questionsCount=${assign.questionsCount}`);
        },
        startDiagnostic(item, assignId, passTypeId) {
            this.loadStartDiagnostic = true;

            this.$http.post(`${this.apiUrl}DiaTestProcess/CreateDiaTestProcess?assignId=${assignId}&diaTestId=${item.testId}&passTypeId=${passTypeId}&studentId=${this.user.id}`)
                .then((res) => {
                this.loadStartDiagnostic = false;
                    this.$router.push(`/lkstudents/dia-test/${res.data.id}?diaTestId=${item.testId}&gender=${item.patientGender}&age=${item.patientAge}`);
                })
        },
        searchDebounce: debounce(function (text) {
            if (text && text.length > 0) {
                this.params.filters = [
                    { fieldName: 'title', filterType: 2, filterValueType: 1, value1: text, value2: '', values: [] },
                    { fieldName: 'studyDisciplineName', filterType: 2, filterValueType: 1, value1: text, value2: '', values: [] },
                    { fieldName: 'studyTopicName', filterType: 2, filterValueType: 1, value1: text, value2: '', values: [] }
                ];

                if(this.currentType === 1) {
                    this.params.filters.push(
                        { fieldName: 'patientFio', filterType: 2, filterValueType: 1, value1: text, value2: '', values: [] }
                    );
                }
            } else {
                this.params.filters = [];
            }

            this.params.currentPage = 0;
            this.loadTasks();
        }, 1000),
    },
    created() {
        if (window.innerWidth <= 500) {
            this.params.pageSize = 5;
        }
        this.currentType = Number(localStorage.getItem('taskTypeM')) || 0;
        this.loadPassTypes();
        this.loadTasks();
    }
}
</script>
